export default __webpack_public_path__ + "static/media/users-solid.90efc33f.svg";